import { render, staticRenderFns } from "./MapBays.vue?vue&type=template&id=8d048c0c&scoped=true&"
import script from "./MapBays.vue?vue&type=script&lang=js&"
export * from "./MapBays.vue?vue&type=script&lang=js&"
import style0 from "./MapBays.vue?vue&type=style&index=0&id=8d048c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d048c0c",
  null
  
)

export default component.exports